import { TIconNames } from 'components/Icon';
import { TUserRoleUi } from 'data/types/user.types';
import { lazy } from 'react';
import { PrivateRouteType, RoutesPaths } from '../Routes.types';

const IssueTypes = lazy(
  () => import('pages/private/Configurations/Issues/Issues'),
);
const Queues = lazy(() => import('pages/private/Configurations/Queues/Queues'));
const Settings = lazy(() => import('pages/private/Settings/Settings'));
const CategorySettings = lazy(
  () =>
    import('pages/private/Configurations/CategorySettings/CategorySettings'),
);
const PSL = lazy(() => import('pages/private/Configurations/PSL/AllPSL'));
const QueueDetails = lazy(
  () => import('pages/private/Configurations/Queues/QueueDetails'),
);
const ContractTypes = lazy(
  () => import('pages/private/Configurations/ContractTypes/ContractTypes'),
);
const WorkTypes = lazy(
  () => import('pages/private/Configurations/WorkTypes/WorkTypes'),
);
const ChecklistTemplates = lazy(
  () =>
    import(
      'pages/private/Configurations/ChecklistTemplates/ChecklistTemplates'
    ),
);
const Notifications = lazy(
  () => import('pages/private/Configurations/Notifications/Notifications'),
);
const System = lazy(() => import('pages/private/Configurations/System/System'));

export const ConfigurationSubRoutes: PrivateRouteType[] = [
  {
    title: 'Issue Types',
    component: IssueTypes,
    path: RoutesPaths.IssueTypes,
    index: true,
    icon: TIconNames.ISSUE_TYPE,
    roles: [TUserRoleUi.Admin, TUserRoleUi.Owner],
  },
  {
    title: 'Queues',
    component: Queues,
    path: RoutesPaths.Queues,
    icon: TIconNames.QUEUE,
    roles: [TUserRoleUi.Admin, TUserRoleUi.Owner],
  },
  {
    title: 'Services and Products',
    component: PSL,
    path: RoutesPaths.PSL,
    index: true,
    icon: TIconNames.PSL,
    roles: [TUserRoleUi.Admin, TUserRoleUi.Technician, TUserRoleUi.Owner],
  },
  {
    title: 'Settings',
    component: Settings,
    path: RoutesPaths.Settings,
    icon: TIconNames.TUNE,
    roles: [TUserRoleUi.Admin, TUserRoleUi.Technician, TUserRoleUi.Owner],
  },
  {
    title: 'Category Settings',
    component: CategorySettings,
    path: RoutesPaths.CategorySettings,
    icon: TIconNames.CATEGORY_SETTINGS,
    roles: [TUserRoleUi.Admin, TUserRoleUi.Owner],
  },
  {
    title: 'Contract Types',
    component: ContractTypes,
    roles: [TUserRoleUi.Admin, TUserRoleUi.Owner],
    path: RoutesPaths.ContractTypes,
    icon: TIconNames.CONTRACT_TYPE,
  },
  {
    // ZEST-759. Owner/Admin only, matching Category Settings and Contract Types — the other
    // two catalogs that shape billing.
    title: 'Work Types',
    component: WorkTypes,
    roles: [TUserRoleUi.Admin, TUserRoleUi.Owner],
    path: RoutesPaths.WorkTypes,
    icon: TIconNames.PROFILE,
  },
  {
    // ZEST-744. Technicians are included because a template's creator may manage it (and they can
    // create templates from the ticket checklist tab); per-row actions are gated on canModify.
    title: 'Checklist Templates',
    component: ChecklistTemplates,
    roles: [TUserRoleUi.Admin, TUserRoleUi.Owner, TUserRoleUi.Technician],
    path: RoutesPaths.ChecklistTemplates,
    icon: TIconNames.TASK,
  },
  {
    title: 'Notifications',
    component: Notifications,
    roles: [TUserRoleUi.Admin, TUserRoleUi.Owner],
    path: RoutesPaths.Notifications,
    icon: TIconNames.UNREAD,
    featureFlag: 'notifications',
  },
  {
    component: QueueDetails,
    path: RoutesPaths.QueueDetails,
    notInSidebar: true,
    roles: [TUserRoleUi.Admin, TUserRoleUi.Owner],
  },
  {
    title: 'System',
    component: System,
    roles: [TUserRoleUi.Owner],
    path: RoutesPaths.System,
    icon: TIconNames.COGS,
  },
];
